exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "body {\n  font-family: 'Lato', sans-serif;\n  margin: 0;\n  background-color: #fcfcfc; }\n\n.app-components-PlayerCounter-button {\n  position: absolute; }\n\n.app-components-PlayerCounter-container {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center; }\n\n.app-components-PlayerCounter-progressBar {\n  height: 100%;\n  width: 100%; }\n\n.app-components-PlayerCounter-icon {\n  padding-left: 4px;\n  padding-top: 4px; }\n", ""]);

// exports
exports.locals = {
	"button": "app-components-PlayerCounter-button",
	"container": "app-components-PlayerCounter-container",
	"progressBar": "app-components-PlayerCounter-progressBar",
	"icon": "app-components-PlayerCounter-icon"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[path][name]-[local]!./~/postcss-loader!./~/sass-loader!./app/components/PlayerCounter.scss
// module id = 377
// module chunks = 0